/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {updateTriggeredAction} from '../api'

export const useMutationUpdateTriggeredAction = createReactQueryMutationHook('updateTriggeredAction', updateTriggeredAction)
